import * as React from 'react';
import * as _ from 'lodash';
import MoreButton from '../MoreButton';
export default function () {
    return React.createElement('section', { 'id': 'Testimonial' }, React.createElement('div', { 'className': 'text' }, React.createElement('span', {}, React.createElement('i', { 'className': 'icon-quote-open' }), this.props.text, React.createElement('i', { 'className': 'icon-quote-closed' })), React.createElement('div', { 'className': 'author' }, this.props.fullName)), React.createElement('div', {
        'className': 'see-more-testimonials',
        '"': true
    }, React.createElement(MoreButton, { 'url': '/testimonials' })));
}